var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiPlatform(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0883789,
    width: 84,
    height: 84,
    rx: 42,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5259 32.3125H48.3384V29.1875H52.0884C52.9514 29.1875 53.6509 29.887 53.6509 30.75V38.9792L55.2134 41.0625C55.63 41.618 55.63 42.382 55.2134 42.9375L53.6509 45.0209V53.25C53.6509 54.113 52.9514 54.8125 52.0884 54.8125H48.3384V51.6875H50.5259V43.9791L52.0103 42L50.5259 40.0209V32.3125Z",
    fill: "#466AEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5259 30.75C30.5259 29.887 31.2254 29.1875 32.0884 29.1875H35.8384V32.3125H33.6509V40.0209L32.1665 42L33.6509 43.9791V51.6875H35.8384V54.8125H32.0884C31.2254 54.8125 30.5259 54.113 30.5259 53.25V45.0209L28.9634 42.9375C28.5467 42.382 28.5467 41.618 28.9634 41.0625L30.5259 38.9792V30.75Z",
    fill: "#466AEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiPlatform);
export default __webpack_public_path__ + "static/media/MultiPlatform.1284deb8ecf5eeb826b4c2d004f20953.svg";
export { ForwardRef as ReactComponent };